/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ICycleDay } from 'app/shared/model/cycle-day.model';
import { BleedingLevel } from 'app/shared/model/enumerations/bleeding-level.model';
import { BleedingColor } from 'app/shared/model/enumerations/bleeding-color.model';
import { ClotType } from 'app/shared/model/enumerations/clot-type.model';

export interface IBleeding {
  id?: string;
  level?: keyof typeof BleedingLevel | null;
  color?: keyof typeof BleedingColor | null;
  clots?: keyof typeof ClotType | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  cntPadsChanged?: number | null;
  cycleDay?: ICycleDay | null;
}

export const defaultValue: Readonly<IBleeding> = {
  active: false,
  draft: false,
};
